export default "__VITE_ASSET__C8oz9YGs__"